import * as Website from '../../../Config/Website.js';

const init = () => {
  const targetElm = document.getElementById('js-homeCv');
  if(!targetElm) return;
  const toggleElm = targetElm.querySelector('.js-toggle');
  check();
  toggleElm.addEventListener('click', () => {
    targetElm.classList.add(Website.classList.inact);
  });
}


const check = () => {
  const targetElm = document.getElementById('js-homeCv');
  if(!targetElm) return;
  const trigger = document.getElementById('js-homeEntry');
  const triggerRect = trigger.getBoundingClientRect();

  if(triggerRect.top < window.innerHeight) {
    targetElm.classList.remove(Website.classList.actView);
  } else {
    targetElm.classList.add(Website.classList.actView);
  }
}

export {
  init,
  check
}